function outputAccessibilityViolations() {
  const warningOutputed = {}
  const logOutputedWarning = function (violationId, message, severity, tags) {
    if (warningOutputed[violationId] == null || warningOutputed[violationId][message] == null) {
      console.log(`, ${severity}, ${violationId}, ${message}`);
      if (tags) {
        console.log(`, rules, ${violationId}, ${tags}`);
      }
      if (warningOutputed[violationId] == null) {
        warningOutputed[violationId] = {}
      }
      warningOutputed[violationId][message] = message
    }
  }
  axe.run().then(results => {
    if (results.violations.lengt == 0) return
    console.log("logline, severity, element, message, rules")
    for (const violation of results.violations) {
      logOutputedWarning(violation.id, violation.help, violation.impact, violation.tags)
      for (const node of violation.nodes) {
        for (const element of node.any) {
          logOutputedWarning(`${violation.id} > ${element.id}`, element.message, element.impact)
        }
      }
    }
    console.log('')
    console.log(`, estimated time to fix, ${Math.ceil(Object.keys(warningOutputed).length * 30) / 60} minutes`)
  })
}
document.addEventListener("DOMContentLoaded", outputAccessibilityViolations)